<template>
  <div class="infos-widget">
    <MeetingInfos
      ref="infos"
      min
      :view="viewMode"
      :sort-by="infosSortBy"
      as-widget
      hide-header
      :cfg-template-edition="cfgTemplateEdition"
      :display-full-information="infosOptDisplayFullInfo"
      @switchInfoView="viewMode = $event"
      @openFileViewer="$emit('setMaxZIndex', $event)"
      @openTeamSelection="$emit('setMaxZIndex', $event)"
    />
  </div>
</template>

<script>
import $ from 'jquery';
// Components
import MeetingInfos from '@/views/dmp/meeting-infos.vue';
// Mixins
import mixinInfosOptions from '@/mixins/page-options/infos.vue';
import mixinWidgets from '@/mixins/widgets.vue';
import mixinWidgetsBgColor from '@/mixins/widgets-bgcolor-config.vue';

export default {
  name: 'InformationsWidget',

  components: {
    MeetingInfos,
  },

  mixins: [mixinInfosOptions, mixinWidgets, mixinWidgetsBgColor],

  props: {
    infosDefaultViewMode: {
      type: Number,
      default: 0,
    },
    infosSortBy: {
      type: Object,
      default: () => ({ value: 0, desc: false }),
    },
    infosOptDisplayFullInfo: Boolean,
  },

  computed: {
    config() {
      return [
        ...this.infosOptions,
        this.defaultBgColorConfig,
      ];
    },
    // ========= Config options =========
    infosOptDefaultViewMode() {
      return this.infosDefaultViewMode;
    },
    infosOptSortBy() {
      return this.infosSortBy;
    },
    infosOptDisplayFullInformation() {
      return this.infosOptDisplayFullInfo;
    },
    // Query params
    viewMode: {
      get() {
        const viewMode = Number(this.queryParams.viewMode);
        if (!this.infosOptViewModes[viewMode]) return this.infosDefaultViewMode;
        return viewMode;
      },
      set(val) {
        const query = Object.assign({}, this.queryParams, { viewMode: String(val) });
        this.setQueryParams(query);
      },
    },
  },

  watch: {
    infosDefaultViewMode(val) {
      this.viewMode = val;
    },
  },

  mounted() {
    $(window).on(`resizeEnd.${this.uuid}`, this.resize);
  },

  methods: {
    refresh() {
      if (this.$refs.infos) {
        this.$refs.infos.onSizeChanged(true);
      }
    },
    sizeChanged() {
      if (this.$refs.infos) {
        this.$refs.infos.onSizeChanged(true);
      }
    },
  },
};
</script>
